export function getLineHeight(transformer) {
    return Object.freeze({
        normal: createLineHeightToken(transformer, 1.5),
        narrow: createLineHeightToken(transformer, 1.1),
        minimal: createLineHeightToken(transformer, 1),
    });
}
function createLineHeightToken(transformer, lineHeight) {
    return {
        get(fontSize) {
            return transformer.lineHeight(lineHeight, fontSize);
        },
    };
}
